module.exports = __webpack_public_path__ + "img/bigscoot.d7edb71e.png";